import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { BuilderContext, useDrawer } from "react-flow-builder";
import { Form, Button, Input, Select } from "antd";
import { store } from "../../../../../../../redux";
import {
  setDraft,
  getDraftSkills,
} from "../../../../../../../redux/actions/skill";
import { getMetaDataSkills } from "../../../../../../../redux/actions/skill";

const { Option } = Select;
const ToDoSkillConfigForm = () => {
  const dispatch = useDispatch();
  let { selectedNode: node, flowVariables, nodes } = useContext(BuilderContext);
  const { closeDrawer: cancel } = useDrawer();
  const [nodeData, setNodeData] = useState(null);
  const [currentPage, setCurrentPage] = useState(-1);
  const [availableSkills, setAvailableSkills] = useState(null);
  const [availableData, setAvailableData] = useState(null);
  const [selectedVal, setSelectedVal] = useState(null);
  const [form] = Form.useForm();

  const findAndUpdate = (arr, id, payload) => {
    let found = arr.findIndex((i) => i.id == id);
    if (found > -1) {
      arr[found] = { ...arr[found], ...payload };
    } else {
      arr.forEach((element) => {
        if (
          [
            "branch",
            "condition",
            "loop",
            "loop-nodes",
            "try",
            "try-catch-node",
            "review",
            "review-node",
          ].includes(element.type)
        ) {
          findAndUpdate(element.children, id, payload);
        }
      });
    }
    return arr;
  };
  const onChange = (value) => {
    console.log(`selected ${value}`);
    setSelectedVal(value);
  };
  const onSearch = (value) => {
    console.log("search:", value);
  };
  const handleSubmit = async () => {
    try {
      let obj = {};
      const values = await form.validateFields();
      let {
        skillReducer: { trainDraft },
      } = store.getState();
      nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
      obj.skillId = values.skillId;
      const _sName = availableSkills?.filter((i) => {
        if (i.SKILL_METADATA) {
          if (i.SKILL_ID === values.skillId) {
            return i;
          }
        } else {
          if (i.id === values.skillId) {
            return i;
          }
        }
      });
      // obj.skillName = _sName[0].SKILL_NAME;
      // obj.skillDescription = _sName[0].SKILL_DESCRIPTION;
      // obj.skillTemplate = _sName[0].SKILL_METADATA.Template;

      let newActions = findAndUpdate(nodes, nodeData.id, obj);
      store.dispatch(
        setDraft({
          ...trainDraft,
          RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
        })
      );
      cancel();
    } catch (error) {
      console.log("form error");
    }
  };

  useEffect(() => {
    getAvailableSkills();
    return () => {
      console.log("[Unmounting]");
    };
  }, []);

  const getAvailableSkills = async () => {
    let data = { page: currentPage };
    let _availabeData = [];
    const userDraftSkill = await dispatch(getDraftSkills(data));
    let publishedSkill = userDraftSkill?.results?.filter(
      (skill) => skill.TEMPLATE !== "Skill Set"
    );
    setAvailableSkills(publishedSkill);
    publishedSkill?.map((r) => {
      let _payload = {
        label: r.SKILL_NAME,
        value: r.id,
      };
      _availabeData.push(_payload);
    });
    setAvailableData(_availabeData);
  };
  useEffect(() => {
    setNodeData(node);
  }, [node]);

  return (
    <div>
      {nodeData ? (
        <div>
          <Form form={form} initialValues={nodeData}>
            <Form.Item
              name="skillId"
              label=" Select Skill"
              rules={[{ required: true }]}
            >
              {/* <Select style={{ width: 120 }}>
                {availableSkills?.map((ele, i) => {
                  return (
                    <Option
                      className="custom-select"
                      key={i}
                      value={ele.SKILL_ID ? ele.SKILL_ID : ele.id}
                    >
                      <p>{ele.SKILL_NAME}</p>
                    </Option>
                  );
                })}
              </Select> */}
              <Select
                style={{ width: 120 }}
                showSearch
                placeholder="Select skill"
                optionFilterProp="children"
                onChange={onChange}
                onSearch={onSearch}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={availableData}
              />
            </Form.Item>
          </Form>

          <div>
            <Button onClick={cancel}> Cancel </Button>
            <Button type="primary" onClick={handleSubmit}>
              Save
            </Button>
          </div>
        </div>
      ) : null}
      <ul className="note-list">
        <li>
          Add a ToDo agent created by you or your teams into the onboarding
          process
        </li>
      </ul>
    </div>
  );
};

export default ToDoSkillConfigForm;
